import React from 'react';
import Button from './Button/Button';
import Markdown from 'react-markdown';

const CTA = ({ data }) => (
  <section className='w-full flex flex-col lg:gap-10 gap-14 items-center justify-center lg:py-14 py-20 lg:px-12 px-8 text-center bg-[#D9D9D9]'>
    <Markdown className='text-black text-4xl lg:text-5xl'>{data.text}</Markdown>
    <Button
      text={data.buttonText}
      link={'#contact_form__footer'}
      dark
    />
  </section>
);

export default CTA;
